import RestService from '../services/rest';

async function searchSphereContacts({
  limit, skip, clientId, search,
}) {
  return RestService.getAuthenticated('panel/contacts?'
    + `limit=${limit}&skip=${skip}&clientId=${clientId}&search=${search}`);
}

export default {
  searchSphereContacts,
};
